import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { PageContent } from '../../data-services/models/page-content.model';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectPrivacyPolicy, selectTerms } from '../../data-services/stores/selectors/pages.selectors';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../../loading/feature/loading.component';
import { pagesActions } from '../../data-services/stores/actions/pages.actions';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-page',
  imports: [CommonModule,LoadingComponent],
  templateUrl: '../ui/site-pages.component.html',
  styleUrls: ['../ui/site-pages.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SitePagesComponent implements OnInit{
  private readonly _route = inject(ActivatedRoute);
  private readonly _store = inject(Store);
  private readonly _titleService = inject(Title)

  pageContent$!: Observable<PageContent | undefined>;
  requestedPageContent?: string = this._route.snapshot.data['pageContent'];

  ngOnInit(): void {
    switch (this.requestedPageContent){
      case 'terms':
        this._titleService.setTitle('LRPTickets.co.uk | Terms & Conditions')
        this._store.dispatch(pagesActions.getTerms())
        this.pageContent$ = this._store.select(selectTerms);
        break;
      case 'privacy':
        this._titleService.setTitle('LRPTickets.co.uk | Privacy Policy')
        this._store.dispatch(pagesActions.getPrivacyPolicy())
        this.pageContent$ = this._store.select(selectPrivacyPolicy)
        break;
    }
  }
}
